import { ListPage, AddNewPage } from "./pages";

export function InvoicePage() {
  return <></>;
}

InvoicePage.List = ListPage;
InvoicePage.AddNew = AddNewPage;
